import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

export const SliderContext = createContext();

export const SliderProvider = ({ children, isChecked }) => {
  const labels = {};

  if (isChecked) {
    labels.checked = {
      text: 'homecard.label.checked',
      labelType: 'checked'
    };
  }

  return (
    <SliderContext.Provider value={labels}>{children}</SliderContext.Provider>
  );
};

SliderProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  isChecked: PropTypes.bool
};

SliderProvider.defaultProps = {
  isChecked: false
};

export const SliderConsumer = SliderProvider.Consumer;

export const useSliderContext = () => useContext(SliderContext);

export default {
  SliderConsumer,
  SliderProvider,
  SliderContext,
  useSliderContext
};
